import React, { useEffect, useMemo, useState } from 'react'
import { useLocation } from 'react-router-dom'
import Screen from '../../components/Screen';
import api from '../../app/api';
import useAlert from '../../hooks/useAlert';
import Table from "../../components/Table";
import DownloadButton from "../../components/downloadButton"
import ConfirmationPDF from "../shareSubmissions/pdf";
import PDF from "../tasks/PDF";
import RiskPDF from "../tasks/riskAssesmentPdf";
import AuditPDF from "../tasks/auditPdf";
import SubmitButton from '../../components/SubmitButton';
import useAuth from '../../hooks/useAuth';
import { useDispatch, useSelector } from 'react-redux';
import { setPendingTasks, setPendingTasksCount, setShareSubmissions, setShareSubmissionsCount, setSubmittedTasks, setSubmittedTasksCount } from './slice';
export default function Default() {
    const { user } = useAuth()
    const { pendingTasks, totalPendingTasks, submittedTasks, totalSubmittedTasks, shareSubmissions, totalShareSubmissions } = useSelector(state => state.userProfile)
    const [loading, setLoading] = useState(false)
    const dispatch = useDispatch()
    const [pendingFilter, setPendingFilter] = useState({
        page: 1,
        limit: 10
    })
    const [submittedFilter, setSubmittedFilter] = useState({
        page: 1,
        limit: 10
    })
    const [submissionsFilter, setSubmissionsFilter] = useState({
        page: 1,
        limit: 10
    })
    const pendingLabels = ['#', 'Title', 'Status', 'Frequency', 'Task For', 'Created At', 'Action'];
    const submittedLabels = ['#', 'Title', 'Status', 'Frequency', 'Task For', 'Created At', 'Action'];
    const submissionsLabels = ['#', 'Email', 'status', 'Feature', 'Document Count', 'Confirmation', 'Action'];

    const { showAlert } = useAlert()
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const id = location?.state?.id || queryParams.get("id");

    const resendNotification = async (taskId) => {
        try {
            const response = await api.put(`/task/resendNotification`, { taskId: taskId })
            if (response.data.status) {
                showAlert(response.data.message, 'success')
            } else {
                showAlert(response.data.message, 'danger')
            }
        } catch (error) {
            showAlert(error.message, 'danger')
        }
    }
    const getPendingTasks = async () => {
        setLoading(true)
        try {
            const response = await api.get(`/auth/pendingTasks`, { params: { ...pendingFilter, userId: id } })
            if (response.data.status) {
                dispatch(setPendingTasks(response.data?.result?.userPendingTasks))
                dispatch(setPendingTasksCount(response.data?.result?.total))
            } else {
                showAlert('Unable to fetch pending tasks', 'danger')
            }
        } catch (error) {
            showAlert(error.message, 'danger')
        } finally {
            setLoading(false)
        }
    }
    const getSubmittedTask = async () => {
        setLoading(true)

        try {
            const response = await api.get(`/auth/submittedTask`, { params: { ...submittedFilter, userId: id } })
            if (response.data.status) {
                dispatch(setSubmittedTasks(response.data?.result?.userSubmittedTasks))
                dispatch(setSubmittedTasksCount(response.data?.result?.total))
            } else {
                showAlert('Unable to fetch submitted tasks', 'danger')
            }
        } catch (error) {
            showAlert(error.message, 'danger')
        } finally {
            setLoading(false)
        }
    }
    const getUserShareSubmissions = async () => {
        setLoading(true)

        try {
            const response = await api.get(`/auth/shareSubmissions`, { params: { ...submissionsFilter, userId: id } })
            if (response.data.status) {
                dispatch(setShareSubmissions(response.data?.result?.data))
                dispatch(setShareSubmissionsCount(response.data?.result?.total))
            } else {
                showAlert('Unable to fetch email submissions', 'danger')
            }
        } catch (error) {
            showAlert(error.message, 'danger')
        } finally {
            setLoading(false)
        }
    }
    const pendingData = useMemo(() => (
        pendingTasks
            ? pendingTasks.map((item) => {
                return {
                    data: item,
                    fields: [
                        '#',
                        item?.title,
                        item?.status,
                        <td>{item?.riskAssesmentID ? item?.riskAssesmentID?.riskAssesmentFrequency : item?.checklistID ? item?.checklistID?.checklistFrequency : item?.auditID?.auditFrequency || item.checklistFrequency}</td>,
                        item.checklistID ? 'Checklist' : item.riskAssesmentID ? 'Risk Assessment' : 'Audit',
                        new Date(item.timestamp).toLocaleDateString("en-GB"),
                        <SubmitButton
                            icon={"Resend"}
                            loading={'abd' == item._id}
                            onClick={() => {
                                resendNotification(item._id)
                            }}
                            color={"success"}
                            loaderColor={"white"}
                        // disabled={item.subscriptionID?.status == "paid"}
                        />
                    ].filter((it) => it),
                };
            }).filter(item => item) : []
    ), [pendingFilter, pendingTasks]);

    const submittedData = useMemo(() => (
        submittedTasks
            ? submittedTasks.map((item) => {
                return {
                    data: item,
                    fields: [
                        '#',
                        item?.title,
                        item?.status,
                        <td>{item?.riskAssesmentID ? item?.riskAssesmentID?.riskAssesmentFrequency : item?.checklistID ? item?.checklistID?.checklistFrequency : item?.auditID?.auditFrequency || item.checklistFrequency}</td>,
                        item.checklistID ? 'Checklist' : item.riskAssesmentID ? 'Risk Assessment' : 'Audit',
                        new Date(item.timestamp).toLocaleDateString("en-GB"),
                        <td className="d-flex justify-content-between w-100">
                            <DownloadButton
                                PDF={item.riskAssesmentID ? <RiskPDF data={{ ...item, companyID: user }} /> : item.auditId ? <AuditPDF data={{ ...item, companyID: user }} /> : <PDF data={{ ...item, companyID: user }} />}
                                item={item}
                                fileName={item?.title + `.pdf`}
                                pdfButton={<div className="text-danger" style={{ cursor: "pointer" }}>
                                    <i
                                        className="bi bi-file-pdf-fill"
                                        style={{ fontSize: 20 }}
                                    ></i>
                                </div>}
                            />
                        </td>
                    ].filter((it) => it),
                };
            }).filter(item => item) : []
    ), [submittedFilter, submittedTasks]);

    const submissionsData = useMemo(() => (
        shareSubmissions
            ? shareSubmissions.map((item) => {
                return {
                    data: item,
                    fields: [
                        '#',
                        item?.submittedEmail,
                        item?.status,
                        item?.forFeature,
                        item.shareableID?.shareable?.length,
                        <DownloadButton
                            PDF={<ConfirmationPDF data={item} />}
                            item={item}
                            fileName={`email-confirmation-` + item?.submittedEmail + `.pdf`}
                        />,
                        <a
                            href={`/shareView?id=${item.shareableID?._id || item.shareableID}&isUser=${true}&userID=${localStorage.getItem("_id")}`}
                            target="_blank"
                        >
                            View
                        </a>
                    ].filter((it) => it),
                };
            }).filter(item => item) : []
    ), [submissionsFilter, shareSubmissions]);

    useEffect(() => {
        getUserShareSubmissions()
    }, [submissionsFilter])
    useEffect(() => {
        getPendingTasks()
    }, [pendingFilter])
    useEffect(() => {
        getSubmittedTask()
    }, [submittedFilter])
    // useEffect(() => {
    //     getSubmittedTask()
    //     getUserShareSubmissions()
    //     getPendingTasks()
    // }, [])

    return (
        <Screen
            loading={loading}
            flow={[
                { label: "User Profile", to: `/user-profile?id=${id}` },
                { label: "Home", to: "/" },
                { label: "User Profile", to: `/user-profile?id=${id}` },
            ]}
        >
            <Table
                title={'Pending Tasks'}
                labels={pendingLabels}
                data={pendingData}
                limit={pendingFilter.limit}
                setLimit={(limit) => setPendingFilter({ ...pendingFilter, limit })}
                page={pendingFilter.page}
                setPage={(page) => setPendingFilter({ ...pendingFilter, page })}
                totalData={totalPendingTasks}
            />
            <Table
                title={'Submitted Tasks'}
                labels={submittedLabels}
                data={submittedData}
                limit={submittedFilter.limit}
                setLimit={(limit) => setSubmittedFilter({ ...submittedFilter, limit })}
                page={submittedFilter.page}
                setPage={(page) => setSubmittedFilter({ ...submittedFilter, page })}
                totalData={totalSubmittedTasks}
            />
            <Table
                title={'Email Submissions'}
                labels={submissionsLabels}
                data={submissionsData}
                limit={submissionsFilter.limit}
                setLimit={(limit) => setSubmissionsFilter({ ...submissionsFilter, limit })}
                page={submissionsFilter.page}
                setPage={(page) => setSubmissionsFilter({ ...submissionsFilter, page })}
                totalData={totalShareSubmissions}
            />
        </Screen>
    )
}
